import styled from "styled-components/macro"

export const Blur = styled.span`
  filter: blur(0.6rem);
  -webkit-filter: blur(0.6rem);
  margin: 0;
  padding: 0;
`
